
/* titles */
export const TITLE_ONLINE = 'title.online';
export const TITLE_OFFLINE = 'title.offline';
export const TITLE_POPUP = 'title.popup';

/* errors */
export const SERVER_ERROR = 'chat.server-error';
export const CAPTCHA_ERROR = 'captcha-error.message';
export const SESSION_EXPIRED_ERROR = 'session-expired-error.message';
export const VALIDATION_ERRORS_EMPTY = 'validation-errors.empty';
export const VALIDATION_ERRORS_TOO_MUCH = 'validation-errors.too-much';
export const VALIDATION_ERRORS_NOT_ENOUGH = 'validation-errors.not-enough';


export const TOOLTIP_SEND_FILE = 'chat.caller.tooltip.send-file';
export const SEND_TRANSCRIPT_BY_EMAIL = 'chat.caller.tooltip.send-transcript-by-email';
export const SELECT_FILE_TO_SEND = 'chat.caller.send-file.select-file-to-send';
export const LEAVE_ROOM_CONFIRM = 'chat.leave-room-confirm';
export const TRANSFER_INTERRUPTED = 'chat.caller.send-file.transfer-interrupted';
export const START_CHAT_FORM_SEND_A_MESSAGE = 'chat.caller.start-chat-form.send-a-message';
export const FILE = 'common.file';
export const BTN_SEND = 'common.btn.send';
export const LEAVE_ROOM_CONFIRM_POSITIVE = 'chat.leave-room-confirm.positive';
export const EMAIL_SENT_CONFIRMATION = 'chat.caller.email-sent-confirmation.content';
export const SEND_TRANSCRIPT_BY_EMAIL_CONFIRMATION = 'chat.caller.send-transcript-by-email.confirmation';
export const MESSAGE_SEND_PLACEHOLDER = 'chat.caller.message-send-placeholder';
export const PRINT_TRANSCRIPT = 'chat.caller.tooltip.print-transcript';
export const MAXIMIZE = 'header.controls.maximize';
export const RETRY = 'common.retry';
export const CLOSE = 'common.btn.close';
export const PLEASE_TRY_CONTACTING = 'chat.caller.unknown-email-address.please-try-contacting';
export const INVALID_EMAIL_ADDRESS = 'common.invalid-email-address';
export const SEND_FILE_FAIL = 'chat.caller.send-file.fail';
export const MSG_CANT_BE_SENT = 'chat.caller.unknown-email-address.msg-cant-be-sent';
export const SEND_BUTTON = 'chat.caller.tooltip.send-button';
export const EMAIL = 'common.email';
export const NEW_MESSAGE_SOUND_ALERT_ON_OFF = 'chat.caller.tooltip.new-message-sound-alert-on-off';
export const OK = 'common.ok';
export const PLEASE_SELECT = 'common.please-select';
export const MINIMIZE = 'header.controls.minimize';
export const DIRECTION = 'common.direction'; /* the settings page depends on this key */
export const EMAIL_LABEL = 'chat.email-label';
export const CHAT_MESSAGE_EDITED = 'chat.message.edited';
export const ENTER_EMAIL_ADDRESS = 'common.enter-email-address';
export const LEAVE_ROOM_CONFIRM_NEGATIVE = 'chat.leave-room-confirm.negative';
export const SEND_EMAIL = 'common.btn.send-email';
export const LEAVE = 'common.btn.leave';
export const SEND_FILE_SUCCESS = 'chat.caller.send-file.success';
export const BTN_CANCEL = 'common.btn.cancel';
export const SECURE_SSL_CONNECTION = 'common.secure-ssl-connection';
export const SIZE_EXCEEDED = 'chat.caller.send-file.size-exceeded';
export const POWERED_BY = 'powered-by';
export const SEND_EMAIL_TO = 'chat.caller.send-email-form.send-email-to';
export const TOOLTIP_LEAVE_THE_ROOM = 'chat.caller.tooltip.leave-the-room';
export const TOOLTIP_ROOLUP_THE_ROOM = 'chat.caller.tooltip.rollup-the-room';
export const SEND_FILE_TRANSFERRED = 'chat.caller.send-file.transferred';
export const START_CHAT_FORM_START_CHAT = 'chat.caller.start-chat-form.start-chat';
export const LEAVE_ROOM_CONFIRM_TRANSCRIPT = 'chat.leave-room-confirm-transcript';
export const DEFAULT_NICKNAME = 'default-nickname';
export const ACCOUNT_OFFLINE_ERROR_MESSAGE = 'account-offline-error.message';
